// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --date-seleced-color: #1e75ff;
}
.datepicker {
    width: 100%; 
    border: 1px solid var(--gray-100);
    border-radius: 8px;
}
.datepicker-days table {
    width: 100%;
    margin-bottom: 0;
    border-collapse: collapse;
    border: none;
}
.datepicker th.prev, .datepicker th.next, .datepicker th.datepicker-switch {
    border-bottom: 1px solid var(--gray-100);
    height: 45px;
}
.datepicker th { 
    font-weight: 500;
}
.datepicker td, .datepicker th {
    text-align: center;
    height: 40px;
    position: relative;
    padding: 0;
    font-size: 16px;
    vertical-align: middle;
    border: none;
    background-color: transparent !important;
    line-height: normal;
}
.datepicker table tr td.today, .datepicker table tr td.active.active {
    font-weight: 500;
}
.datepicker table tr td.day:not(td.old,td.disabled):hover, .datepicker table tr td.today, .datepicker table tr td.active.active {
    color: #fff;
    cursor: pointer;
}
.datepicker table tr td.old, .datepicker table tr td.disabled, .datepicker table tr .month.disabled {
    color: #81889a;
    opacity: .4;
}

.datepicker table tr td:hover:after, .datepicker table tr td.today:after, .datepicker table tr td.active:after {
    content: "";
    background-color: var(--date-seleced-color);
    height: 40px;
    width: 40px;
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    margin: 0 auto;
    z-index: -1;
    border-radius: 50%;
    top: 50%;
    bottom: 0;
    transform: translateY(-50%);
}
.datepicker-months tr td:hover:after, .datepicker-years tr td:hover:after {
    display: none;
}
.datepicker-months td span, .datepicker-years td span{
    display: inline-block;
    width: calc(25% - 2px);
    height: 54px;
    line-height: 54px;
    margin: 1px;
    cursor: pointer;
    border-radius: 4px;
}
.datepicker-months td span.active, .datepicker-years td span.active {
    background-color: #428bca;
    color: #fff;
    text-shadow: 0 -1px 0 rgba(0, 0, 0, .25);
}
.datepicker-months td span:hover, .datepicker-years td span:hover {
    background-color: #e6effc;
    color: #000;
}`, "",{"version":3,"sources":["webpack://./css/Calender.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,iCAAiC;IACjC,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,wCAAwC;IACxC,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,wCAAwC;IACxC,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;IACX,2CAA2C;IAC3C,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;AAC/B;AACA;IACI,aAAa;AACjB;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,wCAAwC;AAC5C;AACA;IACI,yBAAyB;IACzB,WAAW;AACf","sourcesContent":[":root {\r\n    --date-seleced-color: #1e75ff;\r\n}\r\n.datepicker {\r\n    width: 100%; \r\n    border: 1px solid var(--gray-100);\r\n    border-radius: 8px;\r\n}\r\n.datepicker-days table {\r\n    width: 100%;\r\n    margin-bottom: 0;\r\n    border-collapse: collapse;\r\n    border: none;\r\n}\r\n.datepicker th.prev, .datepicker th.next, .datepicker th.datepicker-switch {\r\n    border-bottom: 1px solid var(--gray-100);\r\n    height: 45px;\r\n}\r\n.datepicker th { \r\n    font-weight: 500;\r\n}\r\n.datepicker td, .datepicker th {\r\n    text-align: center;\r\n    height: 40px;\r\n    position: relative;\r\n    padding: 0;\r\n    font-size: 16px;\r\n    vertical-align: middle;\r\n    border: none;\r\n    background-color: transparent !important;\r\n    line-height: normal;\r\n}\r\n.datepicker table tr td.today, .datepicker table tr td.active.active {\r\n    font-weight: 500;\r\n}\r\n.datepicker table tr td.day:not(td.old,td.disabled):hover, .datepicker table tr td.today, .datepicker table tr td.active.active {\r\n    color: #fff;\r\n    cursor: pointer;\r\n}\r\n.datepicker table tr td.old, .datepicker table tr td.disabled, .datepicker table tr .month.disabled {\r\n    color: #81889a;\r\n    opacity: .4;\r\n}\r\n\r\n.datepicker table tr td:hover:after, .datepicker table tr td.today:after, .datepicker table tr td.active:after {\r\n    content: \"\";\r\n    background-color: var(--date-seleced-color);\r\n    height: 40px;\r\n    width: 40px;\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    text-align: center;\r\n    margin: 0 auto;\r\n    z-index: -1;\r\n    border-radius: 50%;\r\n    top: 50%;\r\n    bottom: 0;\r\n    transform: translateY(-50%);\r\n}\r\n.datepicker-months tr td:hover:after, .datepicker-years tr td:hover:after {\r\n    display: none;\r\n}\r\n.datepicker-months td span, .datepicker-years td span{\r\n    display: inline-block;\r\n    width: calc(25% - 2px);\r\n    height: 54px;\r\n    line-height: 54px;\r\n    margin: 1px;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n}\r\n.datepicker-months td span.active, .datepicker-years td span.active {\r\n    background-color: #428bca;\r\n    color: #fff;\r\n    text-shadow: 0 -1px 0 rgba(0, 0, 0, .25);\r\n}\r\n.datepicker-months td span:hover, .datepicker-years td span:hover {\r\n    background-color: #e6effc;\r\n    color: #000;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
